// @ts-nocheck
import logger from "@insite/client-framework/Logger";
import React from "react";

// reference: https://github.com/uidotdev/usehooks/blob/dfa6623fcc2dcad3b466def4e0495b3f38af962b/index.js fixed up typescript a bit
const dispatchStorageEvent = (key: string, newValue: any) => {
    window.dispatchEvent(new StorageEvent("storage", { key, newValue }));
};
const setLocalStorageItem = <T>(key: string, value: T) => {
    const stringifiedValue = JSON.stringify(value);
    window.localStorage.setItem(key, stringifiedValue);
    dispatchStorageEvent(key, stringifiedValue);
};

const removeLocalStorageItem = (key: string) => {
    window.localStorage.removeItem(key);
    dispatchStorageEvent(key, null);
};

const getLocalStorageItem = (key: string) => {
    return window.localStorage.getItem(key);
};

const useLocalStorageSubscribe = (callback: (event: StorageEvent) => any) => {
    window.addEventListener("storage", callback);
    return () => window.removeEventListener("storage", callback);
};

export function useLocalStorage<T>(
    key: string,
    initialValue?: T,
): [T | undefined, React.Dispatch<React.SetStateAction<T>>] {
    const getSnapshot = () => getLocalStorageItem(key);

    const store = React.useSyncExternalStore(useLocalStorageSubscribe, getSnapshot, () => "");

    const setState = React.useCallback(
        (value: T | ((prevState: T) => T)) => {
            try {
                const nextState = value instanceof Function ? value(JSON.parse(store || "")) : value;

                if (nextState === undefined || nextState === null) {
                    removeLocalStorageItem(key);
                } else {
                    setLocalStorageItem(key, nextState);
                }
            } catch (e) {
                logger.warn(e);
            }
        },
        [key, store],
    );

    React.useEffect(() => {
        if (getLocalStorageItem(key) === null && typeof initialValue !== "undefined") {
            setLocalStorageItem(key, initialValue);
        }
    }, [key, initialValue]);

    return [store ? JSON.parse(store) : initialValue, setState];
}
